module.exports = __webpack_public_path__ + "562cabc194e68fe1eca7e156617a9419.svg";